<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="400px">
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>

      <v-card-text class="mt-0 pt-0 text-sm-left">
        <h3
          class="pl-3 pt-3 pb-2 mb-1 title"
        >
          {{prepositoryData.representative_name ? prepositoryData.representative_name : 'Preposto não encontrado'}}
        </h3>

        <p class="pl-3 mb-1 subheading">
          <v-icon small class="pr-2">email</v-icon>
          <a href="#">{{prepositoryData.representative_email}}</a>
        </p>

        <p class="pl-3 mb-3 subheading">
          <v-icon small class="pr-2">local_phone</v-icon>
          {{prepositoryData.representative_tell | formatTell}}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PrepositoryDetailDlg',

  props: {
    resetDialog: Function,
    dialogShow: Boolean,
    prepositoryData: Object
  },

  filters: {
    formatTell (val) {
      if (val) {
        return val
          .replace(/^(\d{2})(\d)/g, '($1) $2')
          .replace(/(\d)(\d{4})$/, '$1-$2')
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
</style>
